import { useUserStore } from '~/composables/useUserStore';

export default defineNuxtRouteMiddleware(async (to, from) => {
    try {
        // Only use Nuxt composables on the client side
        if (process.client) {
            const { user, fetchUser, token } = useUserStore();

            if (!token.value) {
                return navigateTo('/login');
            }

            
            await fetchUser();

            const role = user.value?.role;

            if (role) {
                if (role === 'admin' || user.value.admin) {
                    return;
                } else {
                    return navigateTo(`/field/feed`);
                }
            }
        }
        // For server-side rendering, allow the request to proceed without authentication
        // The page will handle authentication after hydration
    } catch (error) {
        console.error('Middleware error:', error);
        if (process.client) {
            return navigateTo('/login');  // Fallback if an error occurs
        }
    }
});
